import React from "react";
import { styled } from "@mui/system";
import StarIcon from "@mui/icons-material/Star";
import DoneIcon from "@mui/icons-material/Done";
import SvgIcon from "@mui/material/SvgIcon";
import Stack from "@mui/material/Stack";
import BroadcastIconWithEffect from "../../../public/images/broadcast/BroadcastIconWithEffect.svg";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';

// Main container
const MainContainer = styled("div")({
  width: '100vw',
  minHeight: 700,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: 0,
  margin: 0,
  flex: 1
});

// Secondary container
const SecondaryContainer = styled("div")({
    width: "100vw",
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '160%',
    height: "389px",
    letterSpacing: '0.15px',
    textAlign: 'center',
    justifyItems: "center",
    backgroundSize: "cover",
    backgroundImage: "url('/images/broadcast/confirmedScreenBackground.svg')",
});

// Broadcast icon area
const BroadcastIconBox = styled("div")({
  width: 180,
  height: 180,
  margin: "0 auto 0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  background: "none",
});

const SuccessText = styled(Typography)({
    lineHeight: '133%',
    letterSpacing: '0px',
    fontWeight: 700,
    color: "#FFFFFF",
});

const SupportButton = styled(Button)({
    marginTop: '24px',
    width: '93px',
    height: '30px',
    padding: '16px',
    gap: '8px',
    borderRadius: '16px',
    backgroundColor: '#FFB547',
    fontWeight: '500',
    fontSize: '10px',
    lineHeight: '14px',
    letterSpacing: '0px',
    color: '#621B16'
});

const Card = styled("div")({
    width: "100vw",
    height: "52vh",
    background: "#fff",
    borderRadius: 24,
    boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
    marginTop:'-20px',
    display: "flex",
    flexDirection: "column",
    position: "relative",
    padding: "48px 24px",
});

const CardHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 10,
  marginBottom: 16,
  width: "100vw",
  justifyContent: "space-between",
});

const CardTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: 20,
  color: "#424242",
  display: "flex",
  alignItems: "center",
  gap: 8,
});

const List = styled("ul")({
  listStyle: "none",
  padding: 0,
  margin: 0,
  width: "100%",
  paddingTop:'0.3remrem',
});

const ListItem = styled("li")({
  display: "flex",
  alignItems: "flex-start",
  gap: 10,
  fontSize: 16,
  color: "#424242",
  marginBottom: 18,
});

const CheckIcon = styled(DoneIcon)({
    color: "#003F7D",
    fontSize: '20px',
    marginTop: 2,
});

const DoneButton = styled(Button)({
  width: "100%",
  background: "#000",
  color: "#fff",
  border: "none",
  borderRadius: '12px',
  marginTop: '1rem',
});

export default function SuccessScreen({close}: {close: Function}) {
  return (
    <MainContainer>
        <SecondaryContainer>
            <BroadcastIconBox>
                <SvgIcon
                    component={BroadcastIconWithEffect}
                    inheritViewBox={false}
                    viewBox="-20 00 230 150"
                    sx={{
                        width: '220px',
                        height: '200px',
                    }}
                />
            </BroadcastIconBox>
            <SuccessText variant="h5">
                Your broadcast is been<br />successfully posted
            </SuccessText>
            <SupportButton variant="contained">
                <CallOutlinedIcon fontSize='small'/>
                Support
            </SupportButton>
    </SecondaryContainer>
      <Card>
        <CardHeader>
          <CardTitle variant="h6">
            <StarIcon sx={{ color: "#424242", fontSize: 24, marginRight: 1 }} />
            Whats next to expect ?
          </CardTitle>
        </CardHeader>
        <List>
          <ListItem>
            <CheckIcon />
            Agents will be seeing your request
          </ListItem>
          <ListItem>
            <CheckIcon />
            Agents are trying to connect you back
          </ListItem>
          <ListItem>
            <CheckIcon />
            Agents are finding down the verified leads
          </ListItem>
          <ListItem>
            <CheckIcon />
            Keep an eye on your Inbox
          </ListItem>
        </List>
        <DoneButton variant="contained" onClick={()=>close()}>Done</DoneButton>
      </Card>
    </MainContainer>
  );
}
